import styled from "styled-components";

export const FiltersCard = styled.div`
  background: #f8f9fc;
  border: 1px solid #e6e9ef;
  border-radius: 16px 16px 0 0;
  padding: 24px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: -24px;
`;

export const FiltersTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #293142;
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const FilterLabel = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #767c8f;
`;

export const FiltersActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ApplyFiltersButton = styled.button`
  padding: 8px 12px;
  background: #ef4f5f;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    background: #d0d4dc;
    cursor: not-allowed;
  }
`;

export const ClearAllButton = styled.button`
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  color: #9197a6;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const TableWrapper = styled.div`
  padding-bottom: 0;
  & > div {
    border-radius: 0;
  }
  tr {
    cursor: default;
  }
`;

export const PaginationBarContainer = styled.div`
  margin-top: -24px;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: var(--color-base-grey-200, rgba(230, 233, 239, 1));
  & > div {
    border-radius: 0 0 12px 12px;
    background: #ffffff;
    margin-top: 0;
  }
`;

export const FilterSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const FilterSelectTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #596378;
  cursor: pointer;
`;

export const FilterSelectMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(28, 28, 28, 0.08);
  padding: 8px;
  max-height: 240px;
  overflow-y: auto;
`;

export const FilterSelectOption = styled.div`
  padding: 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #293142;
  font-weight: ${(props) => (props.$selected ? 600 : 400)};
  background: ${(props) => (props.$selected ? "#f4f6fb" : "transparent")};
  cursor: pointer;

  &:hover {
    background: #f4f6fb;
  }
`;

export const FilterCheckboxOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #293142;
  cursor: pointer;

  &:hover {
    background: #f4f6fb;
  }
`;

export const StatusChipSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
`;

export const StatusSummaryChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #e6e9ef;
  border-radius: 4px;
  font-size: 12px;
  color: #596378;
  white-space: nowrap;
`;

export const StatusSummaryMore = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #ef4f5f;
  white-space: nowrap;
`;

export const WarehouseSearchInput = styled.input`
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #e6e9ef;
  border-radius: 6px;
  font-size: 13px;
  color: #293142;
  outline: none;
  margin-bottom: 4px;
  flex-shrink: 0;
  box-sizing: border-box;

  &::placeholder {
    color: #9197a6;
  }
`;

export const WarehouseOptionsList = styled.div`
  overflow-y: auto;
  flex: 1;
`;
